/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Sandboxes_Metaassetstitle2Inputs */

const id_sandboxes_metaassetstitle2 = /** @type {(inputs: Sandboxes_Metaassetstitle2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Assets`)
};

const ms_sandboxes_metaassetstitle2 = /** @type {(inputs: Sandboxes_Metaassetstitle2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aset`)
};

const da_sandboxes_metaassetstitle2 = /** @type {(inputs: Sandboxes_Metaassetstitle2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Assets`)
};

const de_sandboxes_metaassetstitle2 = /** @type {(inputs: Sandboxes_Metaassetstitle2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Assets`)
};

const en_us2_sandboxes_metaassetstitle2 = /** @type {(inputs: Sandboxes_Metaassetstitle2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Assets`)
};

const es_es2_sandboxes_metaassetstitle2 = /** @type {(inputs: Sandboxes_Metaassetstitle2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Assets`)
};

const es_mx2_sandboxes_metaassetstitle2 = /** @type {(inputs: Sandboxes_Metaassetstitle2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Assets`)
};

const fil_sandboxes_metaassetstitle2 = /** @type {(inputs: Sandboxes_Metaassetstitle2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mga Asset`)
};

const fr_sandboxes_metaassetstitle2 = /** @type {(inputs: Sandboxes_Metaassetstitle2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Assets`)
};

const it_sandboxes_metaassetstitle2 = /** @type {(inputs: Sandboxes_Metaassetstitle2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Asset`)
};

const hu_sandboxes_metaassetstitle2 = /** @type {(inputs: Sandboxes_Metaassetstitle2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Asset-ek`)
};

const nl_sandboxes_metaassetstitle2 = /** @type {(inputs: Sandboxes_Metaassetstitle2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Assets`)
};

const no_sandboxes_metaassetstitle2 = /** @type {(inputs: Sandboxes_Metaassetstitle2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Eiendeler`)
};

const pl_sandboxes_metaassetstitle2 = /** @type {(inputs: Sandboxes_Metaassetstitle2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Assets`)
};

const pt_br2_sandboxes_metaassetstitle2 = /** @type {(inputs: Sandboxes_Metaassetstitle2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Assets`)
};

const pt_sandboxes_metaassetstitle2 = /** @type {(inputs: Sandboxes_Metaassetstitle2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Assets`)
};

const ro_sandboxes_metaassetstitle2 = /** @type {(inputs: Sandboxes_Metaassetstitle2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Asset-uri`)
};

const fi_sandboxes_metaassetstitle2 = /** @type {(inputs: Sandboxes_Metaassetstitle2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Resurssit`)
};

const sv_sandboxes_metaassetstitle2 = /** @type {(inputs: Sandboxes_Metaassetstitle2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tillgångar`)
};

const vi_sandboxes_metaassetstitle2 = /** @type {(inputs: Sandboxes_Metaassetstitle2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Assets`)
};

const tr_sandboxes_metaassetstitle2 = /** @type {(inputs: Sandboxes_Metaassetstitle2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Assetler`)
};

const cs_sandboxes_metaassetstitle2 = /** @type {(inputs: Sandboxes_Metaassetstitle2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Assety`)
};

const bg_sandboxes_metaassetstitle2 = /** @type {(inputs: Sandboxes_Metaassetstitle2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Assets`)
};

const ru_sandboxes_metaassetstitle2 = /** @type {(inputs: Sandboxes_Metaassetstitle2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ассеты`)
};

const uk_sandboxes_metaassetstitle2 = /** @type {(inputs: Sandboxes_Metaassetstitle2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Assets`)
};

const ar_sandboxes_metaassetstitle2 = /** @type {(inputs: Sandboxes_Metaassetstitle2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`الأصول`)
};

const hi_sandboxes_metaassetstitle2 = /** @type {(inputs: Sandboxes_Metaassetstitle2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`एसेट्स`)
};

const th_sandboxes_metaassetstitle2 = /** @type {(inputs: Sandboxes_Metaassetstitle2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`แอสเซท`)
};

const ja_sandboxes_metaassetstitle2 = /** @type {(inputs: Sandboxes_Metaassetstitle2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`アセット`)
};

const zh_cn2_sandboxes_metaassetstitle2 = /** @type {(inputs: Sandboxes_Metaassetstitle2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`资源`)
};

const zh_hant1_sandboxes_metaassetstitle2 = /** @type {(inputs: Sandboxes_Metaassetstitle2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`資源`)
};

const ko_sandboxes_metaassetstitle2 = /** @type {(inputs: Sandboxes_Metaassetstitle2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`에셋`)
};

/**
* | output |
* | --- |
* | "Assets" |
*
* @param {Sandboxes_Metaassetstitle2Inputs} inputs
* @param {{ locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
const sandboxes_metaassetstitle2 = /** @type {((inputs?: Sandboxes_Metaassetstitle2Inputs, options?: { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Sandboxes_Metaassetstitle2Inputs, { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_sandboxes_metaassetstitle2(inputs)
	if (locale === "ms") return ms_sandboxes_metaassetstitle2(inputs)
	if (locale === "da") return da_sandboxes_metaassetstitle2(inputs)
	if (locale === "de") return de_sandboxes_metaassetstitle2(inputs)
	if (locale === "en-US") return en_us2_sandboxes_metaassetstitle2(inputs)
	if (locale === "es-ES") return es_es2_sandboxes_metaassetstitle2(inputs)
	if (locale === "es-MX") return es_mx2_sandboxes_metaassetstitle2(inputs)
	if (locale === "fil") return fil_sandboxes_metaassetstitle2(inputs)
	if (locale === "fr") return fr_sandboxes_metaassetstitle2(inputs)
	if (locale === "it") return it_sandboxes_metaassetstitle2(inputs)
	if (locale === "hu") return hu_sandboxes_metaassetstitle2(inputs)
	if (locale === "nl") return nl_sandboxes_metaassetstitle2(inputs)
	if (locale === "no") return no_sandboxes_metaassetstitle2(inputs)
	if (locale === "pl") return pl_sandboxes_metaassetstitle2(inputs)
	if (locale === "pt-BR") return pt_br2_sandboxes_metaassetstitle2(inputs)
	if (locale === "pt") return pt_sandboxes_metaassetstitle2(inputs)
	if (locale === "ro") return ro_sandboxes_metaassetstitle2(inputs)
	if (locale === "fi") return fi_sandboxes_metaassetstitle2(inputs)
	if (locale === "sv") return sv_sandboxes_metaassetstitle2(inputs)
	if (locale === "vi") return vi_sandboxes_metaassetstitle2(inputs)
	if (locale === "tr") return tr_sandboxes_metaassetstitle2(inputs)
	if (locale === "cs") return cs_sandboxes_metaassetstitle2(inputs)
	if (locale === "bg") return bg_sandboxes_metaassetstitle2(inputs)
	if (locale === "ru") return ru_sandboxes_metaassetstitle2(inputs)
	if (locale === "uk") return uk_sandboxes_metaassetstitle2(inputs)
	if (locale === "ar") return ar_sandboxes_metaassetstitle2(inputs)
	if (locale === "hi") return hi_sandboxes_metaassetstitle2(inputs)
	if (locale === "th") return th_sandboxes_metaassetstitle2(inputs)
	if (locale === "ja") return ja_sandboxes_metaassetstitle2(inputs)
	if (locale === "zh-CN") return zh_cn2_sandboxes_metaassetstitle2(inputs)
	if (locale === "zh-Hant") return zh_hant1_sandboxes_metaassetstitle2(inputs)
	return ko_sandboxes_metaassetstitle2(inputs)
});
export { sandboxes_metaassetstitle2 as "sandboxes.metaAssetsTitle" }